import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ChargingStation } from '@models/charging-station';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-restart-charging-station-dialog-content',
  templateUrl: './restart-charging-station-dialog-content.component.html',
  styleUrls: ['./restart-charging-station-dialog-content.component.scss']
})
export class RestartChargingStationDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'RestartChargingStationDialogContentComponent';

  public form: UntypedFormGroup;
  @Input() private entity: string;


  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    private chargingStationsService: ChargingStationsService,
    private toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.formService.form = new UntypedFormGroup({
    });
  }

  onSubmit(formValue) {

    this.chargingStationsService.resetChargingstation(this.entity).subscribe(result => {
      this.toastService.warn('Die Ladestation wird neu gestartet...');
      this.activeModal.close({ isSuccess: result });
    }, error => {
      this.messageService.setError(error);
    });
  }

}
